import { Component, OnInit } from '@angular/core';
import { MessageService, TreeNode } from 'primeng/api';
import { GastosService } from '../../../services/gastos/gastos.service';
import { SeguimientoService } from '../../../services/seguimiento/seguimiento.service';
import { CarteraService } from '../../../services/cartera/cartera.service';

@Component({
  selector: 'app-liquidacion-registro',
  templateUrl: './liquidacion-registro.component.html',
  styleUrls: ['./liquidacion-registro.component.scss'],
  standalone: false,
  providers: [MessageService]
})
export class LiquidacionRegistroComponent implements OnInit {
  loadMenu: boolean = true;
  load: boolean = false;
  dateQuery: Date = new Date();
  token: any = {};
  infoUser: any = {};
  infoPagos: Array<any> = [];
  infoAbonosCartera: Array<any> = [];
  infoGastos: Array<any> = [];
  infoVenta: TreeNode[] = [];
  infoVendedor: Array<any> = [];
  totalPagos: number = 0;
  totalGastos: number = 0;
  totalAbonos: number = 0;


  constructor(private seguimiento: SeguimientoService,
    private message: MessageService,
    private gasto: GastosService,
    private cartera: CarteraService) { }

  ngOnInit(): void {
    this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
    this.infoUser = JSON.parse(localStorage.getItem('infoUser') ?? "[]");
  }

  getInfoVentas = () => {
    this.load = true;
    this.totalPagos = 0;
    this.totalGastos = 0;
    this.infoVendedor = [];

    const dateConvert = this.dateQuery.getFullYear() + '-' + (this.dateQuery.getMonth() + 1) + "-" + this.dateQuery.getDate();
    this.seguimiento.getVentasDiscriminacionPago(this.token.token, dateConvert, dateConvert, this.infoUser.empleadoProveedors[0].idEmpleadoProveedor).subscribe((response) => {
      this.infoPagos = response as Array<any>;
      this.infoPagos.map(row => {
        // las nota credito no ingresan en el valor total de la venta
        if (row.idVentaMetodoPago != 4)
          this.totalPagos += row.valor;
      });

      // obtener gastos
      this.gasto.getGastos(this.token.token, dateConvert, dateConvert).subscribe((resp) => {
        this.infoGastos = resp as Array<any>;
        this.infoGastos.map((row: any) => {
          this.totalGastos += row.valor;
        });
        // obtención de ¡l valor maximo a registrar

        this.infoPagos.map(row => {
          if (row.referencia == "Efectivo")
            row.valor = row.valor - this.totalGastos;/*  */
        });

        this.infoPagos.push({ "referencia": 'Gastos', 'valor': this.totalGastos });

        // obtener abonos de cartera
        this.totalAbonos=0;
        this.cartera.getAbonosCarteraCajero(this.token.token, dateConvert, dateConvert).subscribe((resp1: any) => {
          this.infoAbonosCartera = resp1 as Array<any>;
          this.infoAbonosCartera.forEach(row => {
            this.totalAbonos += row.valor;
          });
        })

      })


      if (this.infoPagos.length > 0) {
        // obtener las ventas por vendedor
        this.seguimiento.getVentasDiscriminacionVendedor(this.token.token, dateConvert, dateConvert).subscribe((response) => {
          this.infoVendedor = response as Array<any>;
          this.load = false;
        })


        // obetener información de las ventas realizadas
        this.seguimiento.getVentasDiscriminacionVenta(this.token.token, dateConvert, dateConvert).subscribe((response) => {
          let data = response as Array<any>;
          let categoria: any = [];
          let clase: any = [];
          let producto: any = []

          data.forEach((row: any) => {
            //**************************  categoria *******************************
            let tempCategoria: number = categoria.findIndex((dat: any) => { return dat.data.id == row.idProductoNavigation.idClaseProductoNavigation.idDepartamentoProductoNavigation.idDepartamentoProducto })

            if (tempCategoria == -1) {
              categoria.push({
                data: {
                  id: row.idProductoNavigation.idClaseProductoNavigation.idDepartamentoProductoNavigation.idDepartamentoProducto,
                  label: row.idProductoNavigation.idClaseProductoNavigation.idDepartamentoProductoNavigation.nombreDepartamento,
                  cantidad: row.cantidad,
                  subtotal: row.subtotal,
                  impuesto: row.impuesto,
                },
                // clase
                children: [{
                  data: {
                    id: row.idProductoNavigation.idClaseProductoNavigation.idClaseProducto,
                    label: row.idProductoNavigation.idClaseProductoNavigation.nombreClaseProducto,
                    cantidad: row.cantidad,
                    subtotal: row.subtotal,
                    impuesto: row.impuesto
                  },
                  // producto
                  children: [{
                    data: {
                      id: row.idProductoNavigation.idProducto,
                      label: row.idProductoNavigation.descripcionCorta,
                      cantidad: row.cantidad,
                      subtotal: row.subtotal,
                      impuesto: row.impuesto
                    }
                  }]
                }]
              });
            }
            else {
              categoria[tempCategoria].data.cantidad += row.cantidad;
              categoria[tempCategoria].data.subtotal += row.subtotal;
              categoria[tempCategoria].data.impuesto += row.impuesto;
              // preguntar si la clase existe dentro del array de categoria
              let tempClase: number = categoria[tempCategoria].children.findIndex((dat: any) => {return dat.data.id == row.idProductoNavigation.idClaseProductoNavigation.idClaseProducto })
              if (tempClase == -1) {
                categoria[tempCategoria].children.push({
                  data: {
                    id: row.idProductoNavigation.idClaseProductoNavigation.idClaseProducto,
                    label: row.idProductoNavigation.idClaseProductoNavigation.nombreClaseProducto,
                    cantidad: row.cantidad,
                    subtotal: row.subtotal,
                    impuesto: row.impuesto
                  },
                  children: [{
                    data: {
                      id: row.idProductoNavigation.idProducto,
                      label: row.idProductoNavigation.descripcionCorta,
                      cantidad: row.cantidad,
                      subtotal: row.subtotal,
                      impuesto: row.impuesto
                    }
                  }]
                });
              }
              else {
                categoria[tempCategoria].children[tempClase].data.cantidad += row.cantidad;
                categoria[tempCategoria].children[tempClase].data.subtotal += row.subtotal;
                categoria[tempCategoria].children[tempClase].data.impuesto += row.impuesto
                // preguntar si el producto ya existe
                let tempProducto: number = categoria[tempCategoria].children[tempClase].children.findIndex((dat: any) => { return dat.data.id == row.idProductoNavigation.idProducto })
                if (tempProducto == -1) {
                  categoria[tempCategoria].children[tempClase].children.push({
                    data: {
                      id: row.idProductoNavigation.idProducto,
                      label: row.idProductoNavigation.descripcionCorta,
                      cantidad: row.cantidad,
                      subtotal: row.subtotal,
                      impuesto: row.impuesto
                    }
                  });
                }
                else {
                  categoria[tempCategoria].children[tempClase].children[tempProducto].data.cantidad += row.cantidad;
                  categoria[tempCategoria].children[tempClase].children[tempProducto].data.subtotal += row.subtotal;
                  categoria[tempCategoria].children[tempClase].children[tempProducto].data.impuesto += row.impuesto
                }
              }
            }
          });

          this.infoVenta = <TreeNode[]>categoria;
        });
      }
      else {
        this.message.add({ severity: 'warn', summary: 'Información', detail: 'No hay información registrada para la fecha consultada' });
        this.load = false;
      }
    });
  }


  printDiv(elem: string, title: string) {
    const dateConvert = this.dateQuery.getFullYear() + '-' + (this.dateQuery.getMonth() + 1) + "-" + this.dateQuery.getDate();

    let mywindow: any = window.open('', 'PRINT', 'height=400,width=800');

    mywindow.document.write('<html><head><title>' + document.title + '</title>');
    mywindow.document.write('<style>.grid {display: flex; margin-right: -.5rem; margin-left: -.5rem;margin-top: -.5rem;} .col-6{ flex: 0 0 auto; padding: .5rem; width:50%}</style>');
    mywindow.document.write('</head><body style="font-family: \'Segoe UI\' !important; font-size: 23px;" >');
    mywindow.document.write('<h4>' + title + ' CORRESPONDIENTE AL DÍA' + dateConvert + '</h4><div style="text-align:center; width:302px">');
    mywindow.document.write(document.getElementById(elem)!.innerHTML);
    mywindow.document.write('</div></body></html>');

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();
    mywindow.close();

    return true;

  }

}
